export default {
  downtimeUrl: "https://www.kodland.org/es",
   parameters: {
    landing_id: "SpQuFreetc5",
    segment: 54,
    success_page: 'success_long'
  },
  startPage: {
    image: "/welcome/spain_freetc_5_euro.png",
    imageMobile: "/welcome/spain_freetc_5_euro_mob.png",
    title: "Responde a 4 preguntas y recibe una clase gratuita para tu hijo/a de 8 a 17 años",
    subtitle: "Tu hijo/a podrá participar en la clase que prefiera",
    button: "Comenzar 🚀",
  },
  successPage: {
    title: "¡Enhorabuena! 🎁",
    subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
    button: "📆 Reservar una clase",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que tu hijo aprovechara el tiempo frente al ordenador aprendiendo cosas nuevas?",
      answers: ["🔥 ¡Sí, me encantaría!", "🤗 Prefiero que lo use solo para divertirse, y está bien así"],
    },
    2: {
      question: "¿Cuál es la asignatura favorita de tu hijo en la escuela?",
      answers: [
        "Lenguas",
        "Matemáticas",
        "Ciencias naturales",
        "Historia",
        "Geografía",
        "Arte",
        "Educación física",
        "Otro"
      ],
    },
    3: {
      question:
        "En estos momentos, ¿qué es lo más importante para ti en el desarrollo de tu hijo?",
      answers: [
        "🤔 Habilidades sociales y emocionales",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    4: {
      question: "¿Tienes un ordenador fijo o portátil en el que puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
  },
};